import jsCookie from "js-cookie";

//
import AppSidebar from "../sidebar";
import AppFooter from "../footer";
import { ListingProvider } from "../sidebar/DraftProvider";
import AuthHeader from "src/components/@auth/auth-layout/auth-header";
import AuthFooter from "src/components/@auth/auth-layout";
import { useCallback, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { getCurrentSession, getUserDetails } from "../../stores/auth";
import { getSessionDetails } from "../../stores/session";
// import AppHeader from "../header";
// import AppHeader from "../header";

/**
 *
 */

interface PathPersistRefProps {
  path: string | null;
}

export default function DefaultLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = (isOpen: boolean) => {
    setIsSidebarOpen(isOpen);
  };

    const PathPersistRef = useRef<PathPersistRefProps>({
      path: `${window.location.pathname}${window.location.search}`,
    });

  const accessToken = jsCookie.get("pn_refresh");

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

      const authStore = useAppSelector((state) => state.auth);
  
    const getSession = useCallback(async () => {
      const session = await dispatch(getCurrentSession()).unwrap();
  
      if (!session.success) {
        if (PathPersistRef.current.path) {
          return navigate(`/login?callback_path=${encodeURIComponent(PathPersistRef.current.path)}`);
        } else {
          return navigate("/login");
        }
      }
  
      if (authStore.token) {
        await dispatch(getSessionDetails());
        await dispatch(getUserDetails());
        return;
      }
  
    }, [authStore.token, dispatch, navigate]);
  
    useEffect(() => {
      getSession();
    }, [getSession, navigate]);

  return (
    <ListingProvider>
      {accessToken ? (
        <div className="h-screen flex flex-col">
          <AppSidebar onSidebarToggle={handleSidebarToggle} />
          <div
            className={`mb-auto flex-1  flex-col flex ${
              isSidebarOpen ? "ml-[256px]" : "ml-[56px]"
            }`}
          >
            <div className="flex flex-auto h-full">
              <div className="h-full w-full duration-500 px-4 flex-auto">
                {/* {location.pathname !== "/q&a" && <AppHeader />} */}
                <div className="relative h-full w-full pl-1 flex justify-center">
                  <Outlet />
                </div>
              </div>
            </div>
            <AppFooter />
          </div>
        </div>
      ) : (
        <div className="h-[600px]">
          <AuthHeader />
          <Outlet />
          <div className="w-full">
            <AuthFooter />
          </div>
        </div>
      )}
    </ListingProvider>
  );
}
